import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "dua-root",
  templateUrl: "./app.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  title = "DUA";
  isIframe: boolean = false;

  constructor(private translateService: TranslateService) {
    translateService.setDefaultLang("sv");
  }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
    this.translate("sv");
  }

  translate(lang: string) {
    this.translateService.use(lang);
  }
}
